/* eslint-disable react/jsx-no-bind, react-native/no-inline-styles */
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getLobbyConfig } from '../../../../lobby/functions';
import { isRoomNameEnabled } from '../../../../prejoin/functions.web';
import Toolbox from '../../../../toolbox/components/web/Toolbox';
import { isButtonEnabled } from '../../../../toolbox/functions.web';
import { getConferenceName } from '../../../conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../config/constants';
import { openSettingsDialog } from '../../../../settings/actions.web';
import { SETTINGS_TABS } from '../../../../settings/constants';
import { isPreCallTestEnabled } from '../../functions';
import Preview from './Preview';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            height: '100%',
            position: 'absolute',
            inset: '0 0 0 0',
            display: 'flex',
            backgroundColor: theme.palette.preMeetingBackground,
            zIndex: 252,
            '@media (max-width: 720px)': {
                flexDirection: 'column-reverse'
            }
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
            boxSizing: 'border-box',
            padding: '24px 0 16px',
            position: 'relative',
            width: '400px',
            height: '100%',
            zIndex: 252,
            '@media (max-width: 720px)': {
                height: 'auto',
                margin: '0 auto'
            },
            // mobile phone landscape
            '@media (max-width: 420px)': {
                padding: '16px 16px 0 16px',
                width: '100%'
            },
            '@media (max-width: 400px)': {
                padding: '16px'
            }
        },
        contentControls: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            margin: 'auto',
            width: '100%'
        },
        paddedContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0 50px',
            '& > *': {
                width: '100%',
                boxSizing: 'border-box'
            }
        },
        title: {
            ...theme.typography.heading4,
            color: theme.palette.prejoinTitleText,
            marginBottom: theme.spacing(3),
            textAlign: 'center',
            '@media (max-width: 400px)': {
                display: 'none'
            }
        },
        roomNameContainer: {
            width: '100%',
            textAlign: 'center',
            marginBottom: theme.spacing(4)
        },
        roomName: {
            ...theme.typography.heading5,
            color: theme.palette.prejoinRoomNameText,
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
        }
    };
});
const PreMeetingScreen = ({ _buttons, _isPreCallTestEnabled, _premeetingBackground, _roomName, children, className, showDeviceStatus, showRecordingWarning, showUnsafeRoomWarning, skipPrejoinButton, title, videoMuted, videoTrack }) => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();
    const [timeDisplay, setTimeDisplay] = useState('');
    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            const dateStr = now.toLocaleDateString('en-US', options);
            const timeStr = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
            const endNow = new Date(now.getTime() + 60 * 60 * 1000);
            const endTimeStr = endNow.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
            setTimeDisplay(`${dateStr} | ${timeStr} – ${endTimeStr}`);
        };
        updateTime();
        const interval = setInterval(updateTime, 60000);
        return () => clearInterval(interval);
    }, []);
    const onBgClick = () => {
        dispatch(openSettingsDialog(SETTINGS_TABS.VIRTUAL_BACKGROUND));
    };
    return (React.createElement("div", { className: clsx('fresh-call-prejoin-wrapper', className) },
        React.createElement("div", { className: 'fc-header' },
            React.createElement("div", { className: 'fc-logo' },
                React.createElement("img", { alt: 'logo', src: 'images/favicon.svg' }),
                React.createElement("span", null, "fresh call")),
            React.createElement("div", { className: 'fc-user' },
                React.createElement("div", { className: 'fc-avatar' }, "S"),
                React.createElement("span", { className: 'fc-username' }, "Sourav \u25BE"))),
        React.createElement("div", { className: 'fc-main-content' },
            React.createElement("div", { className: 'fc-left-panel' },
                React.createElement("div", { className: 'fc-preview-wrapper' },
                    React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack }),
                    React.createElement("div", { className: 'fc-bg-effects-pill', onClick: onBgClick, style: { cursor: 'pointer' } }, "\u2728 Background effects"),
                    React.createElement("div", { className: 'fc-preview-toolbox' }, _buttons.length > 0 && React.createElement(Toolbox, { toolbarButtons: _buttons })))),
            React.createElement("div", { className: 'fc-right-panel' },
                React.createElement("h3", { className: 'fc-prejoin-title' }, "You're about to join"),
                React.createElement("h1", { className: 'fc-room-name' }, _roomName),
                React.createElement("div", { className: 'fc-date-info' },
                    React.createElement("img", { alt: 'cal', className: 'fc-cal-icon', src: 'images/calendar.svg' }),
                    " ",
                    timeDisplay),
                React.createElement("div", { className: 'fc-info-banner' },
                    React.createElement("span", { className: 'fc-info-icon' }, "\u2139\uFE0F"),
                    " Check your audio and video settings before joining."),
                React.createElement("div", { className: 'fc-form-area' },
                    React.createElement("label", { className: 'fc-label' }, "Your name"),
                    children)))));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, prejoinConfig } = state['features/base/config'];
    const { toolbarButtons } = state['features/toolbox'];
    const { knocking } = state['features/lobby'];
    const { showHangUp: showHangUpLobby = true } = getLobbyConfig(state);
    const { showHangUp: showHangUpPrejoin = true } = prejoinConfig || {};
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const shouldShowHangUp = knocking ? showHangUpLobby : showHangUpPrejoin;
    if (shouldShowHangUp && !premeetingButtons.includes('hangup')) {
        premeetingButtons.push('hangup');
    }
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isButtonEnabled(b, toolbarButtons)),
        _isPreCallTestEnabled: isPreCallTestEnabled(state),
        _premeetingBackground: premeetingBackground,
        _roomName: isRoomNameEnabled(state) ? getConferenceName(state) : ''
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
